import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../core/services/user.service";
import { User } from "../../core/models/user.model";

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {

    logout: string;
    user: User;

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private router: Router
    ) {}

    ngOnInit() {

        this.route.queryParams.subscribe(params => {
            Object.keys(params).forEach(key => {
                if (params[key] !== 'logout') {
                    this.user = null;
                    this.userService.purgeAuth();
                    this.router.navigateByUrl('/login');
                }
            });
        });
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/access-denied/access-denied.component.ts